import {
  FeatureFlag,
  useFeatureFlag,
  useFeatureFlagsStatus,
} from "../contexts/launchDarklyContext";

export type RespectOptroPermissions = "on" | "off";

/**
 * Whether Midship enforces Optro view access on linked controls and work
 * steps: the page guards, the list side panels and the list notice. The
 * backend reads the same `respect-optro-permissions` flag.
 *
 * "off" until flags are authoritative for the signed-in workspace/user, and
 * if LaunchDarkly can't be reached (or identify fails or times out), so pages
 * render as they do with the flag off unless LaunchDarkly confirms it is on.
 * The backend enforces the flag on its own, so a page that renders before
 * that answer still gets no data Optro refuses.
 */
export function useRespectOptroPermissions(): RespectOptroPermissions {
  const status = useFeatureFlagsStatus();
  const enabled = useFeatureFlag(FeatureFlag.respectOptroPermissions);
  return status === "ready" && enabled ? "on" : "off";
}
